// The pages that belong to one AI, in the order the left rail shows them.
// Add a page here when a Setup section becomes a page of its own.
export const ASSISTANT_PAGES = [
  {
    route: 'ailab_ai_studio_overview',
    label: 'Overview',
    icon: 'i-lucide-layout-dashboard',
  },
  {
    route: 'ailab_ai_studio_identity',
    label: 'Identity & tone',
    icon: 'i-lucide-user',
  },
  {
    route: 'ailab_ai_studio_qa',
    label: 'Q&A',
    icon: 'i-lucide-message-circle',
  },
  {
    route: 'ailab_ai_studio_files',
    label: 'Files & URLs',
    icon: 'i-lucide-file-text',
  },
  {
    route: 'ailab_ai_studio_images',
    label: 'Images',
    icon: 'i-lucide-image',
  },
  {
    route: 'ailab_ai_studio_answer',
    label: 'Answer mode & style',
    icon: 'i-lucide-shield-check',
  },
  {
    route: 'ailab_ai_studio_language',
    label: 'Language & locale',
    icon: 'i-lucide-languages',
  },
  {
    route: 'ailab_ai_studio_handoff',
    label: 'Handoff & auto-close',
    icon: 'i-lucide-life-buoy',
  },
  {
    route: 'ailab_ai_studio_channels',
    label: 'Channels & activate',
    icon: 'i-lucide-radio',
  },
  {
    route: 'ailab_ai_studio_playground',
    label: 'Playground',
    icon: 'i-lucide-message-square-text',
  },
  {
    route: 'ailab_ai_studio_manage',
    label: 'Setup',
    icon: 'i-lucide-sliders-horizontal',
  },
  {
    route: 'ailab_ai_studio_dashboard',
    label: 'Dashboard',
    icon: 'i-lucide-bar-chart-3',
  },
  {
    route: 'ailab_ai_studio_insights',
    label: 'Insights',
    icon: 'i-lucide-line-chart',
  },
];

export const assistantNavItems = activeRoute =>
  ASSISTANT_PAGES.map(page => ({
    ...page,
    active: page.route === activeRoute,
  }));

// True on any page of one AI Studio assistant (not the list).
export const isAiStudioAssistantRoute = (routeName, params = {}) =>
  String(routeName || '').startsWith('ailab_ai_studio_') &&
  routeName !== 'ailab_ai_studio_index' &&
  Boolean(params?.assistantId);

// The secondary sidebar's items while inside one AI — shaped for the
// dashboard's SidebarGroup (same component as "AI Studio" / "AI Closer"), so
// the font, size and spacing are the ones every other menu uses.
// `route(name, params)` builds an account-scoped route object.
export const assistantSidebarItems = ({ assistantId, route }) => [
  {
    name: 'ai_studio_all_ais',
    label: 'All AIs',
    icon: 'i-lucide-arrow-left',
    to: route('ailab_ai_studio_index'),
  },
  ...ASSISTANT_PAGES.map(page => ({
    name: `ai_studio_${page.route}`,
    label: page.label,
    icon: page.icon,
    to: route(page.route, { assistantId }),
    activeOn: [page.route],
  })),
];
